<mat-card class="dialog-card">
  <button class="close-btn" mat-icon-button (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>

  <h2 mat-dialog-title>{{'myCommissions.shared.title'|traduccion}}</h2>

  <mat-dialog-content class="space-y-4">
    <section>
      <h3 class="text-base font-medium m-0">{{'myCommissions.shared.linkToShare'|traduccion}}</h3>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>URL</mat-label>
        <input matInput [value]="commissionLink" readonly aria-label="URL para copiar" />
        <button mat-icon-button matSuffix (click)="saveClipboard(commissionLink)" aria-label="Copiar URL al portapapeles" matTooltip="Copiar URL">
          <mat-icon>content_copy</mat-icon>
        </button>
        <mat-hint>{{'myCommissions.shared.copyManual'|traduccion}}</mat-hint>
      </mat-form-field>
    </section>

    <section>
      <h3 class="text-base font-medium m-0">{{'myCommissions.shared.discountCode'|traduccion}}</h3>

      <ng-container *ngIf="discountCodes.length; else noDiscountCodes">
        <div class="discount-code-list">
          <mat-form-field appearance="outline" class="w-full" *ngFor="let discountCode of discountCodes">
            <mat-label>{{ discountCode.locationName || ('myCommissions.shared.location'|traduccion) }}</mat-label>
            <input
              matInput
              [value]="discountCode.code"
              readonly
              [attr.aria-label]="'Código de descuento para ' + discountCode.locationName"
            />
            <button
              mat-icon-button
              matSuffix
              (click)="saveClipboard(discountCode.code)"
              [attr.aria-label]="'Copiar código de descuento de ' + discountCode.locationName"
              matTooltip="Copiar código"
            >
              <mat-icon>content_copy</mat-icon>
            </button>
            <mat-hint>{{'myCommissions.shared.location'|traduccion}}: {{ discountCode.locationName }}</mat-hint>
          </mat-form-field>
        </div>
      </ng-container>

      <ng-template #noDiscountCodes>
        <p class="empty-discount-codes">{{'myCommissions.shared.noDiscountCodes'|traduccion}}</p>
      </ng-template>
    </section>
  </mat-dialog-content>
</mat-card>
